import { useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import './styles/fonts.css';
import './styles/globals.css';

import logo from './assets/logo.svg';
import vector1 from './assets/vector_1.svg';
import vector2 from './assets/vector_2.svg';

export default function App() {
    const [gender, setGender] = useState('');
    const [height, setHeight] = useState('');
    const [weight, setWeight] = useState('');
    const [result, setResult] = useState(null);
    const resultRef = useRef(null);

    const calculateCalories = () => {
        const h = parseFloat(height);
        const w = parseFloat(weight);
        const a = 30;
        if (!h || !w || !gender) return;
        const base = 10 * w + 6.25 * h - 5 * a;
        let total = gender === 'female' ? base - 161 : base + 5;
        
        if (total > 1580) total = 1580;
        setResult(Math.round(total));
    
        setTimeout(() => {
            if (resultRef.current) {
                const y = resultRef.current.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top: y - 100, behavior: 'smooth' });
            }
        }, 300);
    };



    return (
        <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4 pt-10 md:pt-20 relative text-white overflow-hidden font-ttfirs">
            <img src={vector2} alt="vector2" className="hidden md:block absolute top-0 right-0 z-0 pointer-events-none w-48 md:w-64"/>
            <img src={vector1} alt="vector1" className="absolute bottom-0 left-0 z-0 pointer-events-none w-32 md:w-48" />

            <div className={`z-10 mb-6 flex flex-col items-center transition-all duration-300 ${result !== null ? 'pt-10' : 'mt-[-100px]'}`}>
                <img src={logo} alt="Логотип" className="h-8 mb-6" />
                <h1 className="text-4xl font-medium text-center">Калькулятор калорий</h1>
            </div>

            <div className="relative z-10 bg-[#111] px-8 py-14 rounded-[30px] shadow-xl w-full max-w-[800px] space-y-6 text-left mb-4">
                <div className="space-y-3">
                    <p className="text-base font-normal">Укажите ваш пол</p>
                    <div className="flex gap-6">
                        <label className="flex items-center gap-2 cursor-pointer relative">
                            <input
                                type="radio"
                                name="gender"
                                value="male"
                                checked={gender === 'male'}
                                onChange={() => setGender('male')}
                                className="w-5 h-5 rounded-full border border-[#555] bg-[#111] checked:border-[#CAFC3B] appearance-none relative cursor-pointer
                  before:content-[''] before:absolute before:top-1 before:left-1 before:w-2.5 before:h-2.5 before:rounded-full
                  before:bg-[#CAFC3B] before:scale-0 checked:before:scale-100 transition-all"
                            />
                            <span>Мужской</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer relative">
                            <input
                                type="radio"
                                name="gender"
                                value="female"
                                checked={gender === 'female'}
                                onChange={() => setGender('female')}
                                className="w-5 h-5 rounded-full border border-[#555] bg-[#111] checked:border-[#CAFC3B] appearance-none relative cursor-pointer
                  before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2
                     before:w-2.5 before:h-2.5 before:rounded-full
                  before:bg-[#CAFC3B] before:scale-0 checked:before:scale-100 transition-all"
                            />
                            <span>Женский</span>
                        </label>
                    </div>
                </div>

                <div className="space-y-2">
                    <label className="text-sm font-normal">Ваш рост (в сантиметрах)</label>
                    <input
                        type="number"
                        placeholder="Введите ваш рост"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="input"
                    />
                </div>

                <div className="space-y-2">
                    <label className="text-sm font-normal">Ваш вес сейчас</label>
                    <input
                        type="number"
                        placeholder="Введите ваш вес"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        className="input"
                    />
                </div>

                <button
                    onClick={calculateCalories}
                    disabled={!gender || !height || !weight}
                    className="btn font-medium"
                >
                    Рассчитать
                </button>
            </div>
            <AnimatePresence>
                {result !== null && (
                    <motion.div
                        ref={resultRef}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 30 }}
                        transition={{ duration: 0.4, ease: 'easeOut' }}
                        className="relative z-10 bg-[#111] px-8 py-10 rounded-[30px] shadow-xl w-full max-w-[800px] text-left space-y-8 mb-16"
                    >
                <div>
                        <p className="text-lg font-medium">Ваша калорийность</p>
                        <p className="text-sm text-[#888] mt-1">Ваша дневная калорийность составит:</p>
                        <p className="text-[#CAFC3B] text-2xl font-medium mt-1">{result} ккал</p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                            <p className="font-medium">Белки</p>
                            <p className="text-sm text-[#888]">Рекомендуемое количество белка в граммах</p>
                            <p className="text-[#2FD6FF] text-xl font-medium mt-1">
                                {Math.round((result * 0.35) / 4)} гр
                            </p>
                        </div>
                        <div>
                            <p className="font-medium">Жиры</p>
                            <p className="text-sm text-[#888]">Рекомендуемое количество жиров в граммах</p>
                            <p className="text-[#2FD6FF] text-xl font-medium mt-1">
                                {Math.round((result * 0.35) / 9)} гр
                            </p>
                        </div>
                        <div>
                            <p className="font-medium">Углеводы</p>
                            <p className="text-sm text-[#888]">Рекомендуемое количество углеводов в граммах</p>
                            <p className="text-[#2FD6FF] text-xl font-medium mt-1">
                                {Math.round((result * 0.3) / 4)} гр
                            </p>
                        </div>
                    </div>
                </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
